import FlipCard from '../../../Components/FlipCard/FlipCard.view'
import cdtLogo from './Assets/cdt-logo.svg'
import zixLogo from './Assets/zixxar-x-logo.svg'
import roFlag from './Assets/RO.svg'
import usFlag from './Assets/us.svg'
import grFlag from './Assets/gr.svg'

// photos
import dummyPhoto from './Assets/npc_img.png'
import profileBogdan from './Assets/profile_bogdan.png'
import profileOvidiu from './Assets/profile_ovidiu.png'
import profileCosmin from './Assets/profile_cosmin.png'
import profileEmanuel from './Assets/profile_emanuel.png'
import profilePanos from './Assets/profile_panos.png'
import profileByron from './Assets/profile_byron.jpeg'
import profileOctavian from './Assets/profile_octavian.jpeg'

import cryptodataLogo from './Assets/cdt-vertical-logo.png'

const SPEAKERS_FLIP = [
  {
    id: 1,
    logo: cdtLogo,
    position: 'Global Strategy',
    country: roFlag,
    photo: profileBogdan,
    name: 'Bogdan Maruntis',
    description:
      'I am truly grateful for the hard-working community that has put their trust in us and what we have. The best is yet to come!',
    backDescription:
      'A business-savvy entrepreneur and former Romanian Air Force fighter pilot, Bogdan Maruntis is not only Head of Global Strategy at CryptoDATA, but is also one of its co-founders. His vast experience in many different fields has helped propel CryptoDATA and ZiXXar to where they are today.',
    company: cryptodataLogo,
    expertise: ['air force', 'business'],
    socialIcons: [],
  },
  {
    id: 2,
    logo: cdtLogo,
    position: 'CEO',
    country: roFlag,
    photo: profileOvidiu,
    name: 'Ovidiu Toma',
    description:
      'This event will be an amazing opportunity for us to learn together, grow closer to our community, and show everyone the wonderful things that are to come.',
    backDescription:
      'Described by journalists as an engineering pioneer who develops and implements innovative technologies in various industries, Ovidiu Toma is not only the CEO of CryptoDATA, but also one of its co-founders.',
    company: cryptodataLogo,
    expertise: [
      'blockchain',
      'cybersecurity',
      'telecommunications',
      'engineering',
      'artificial intelligence',
    ],
    socialIcons: [],
  },
  {
    id: 4,
    logo: zixLogo,
    position: 'WTX',
    country: roFlag,
    photo: profileEmanuel,
    name: 'Emanuel Popa',
    description:
      'ZiXXar will make history not only in the blockchain world, but especially in the network marketing industry. This event in Barcelona will serve as the cornerstone for the European market.',
    backDescription:
      'Emanuel has 14 years of network marketing experience and 26 years of experience in public speaking. He is one of the founding members of the John Maxwell Team, is active in NGOs and was a director of training for a European company.',
    company: '',
    expertise: [
      'Network Marketing',
      'Public Speaking',
      'Mentoring',
      'NGOs',
      'Director of Training',
    ],
    socialIcons: [],
  },
  {
    id: 5,
    logo: zixLogo,
    position: 'WTX',
    country: roFlag,
    photo: profileCosmin,
    name: 'Cosmin Tronaru',
    description:
      'This event is the first big European step in building a Legacy. You cannot build a system overnight, but you can lay the strong foundation it needs to grow upon. Barcelona awaits.',
    backDescription:
      'With years of experience as a programmer, public speaker, and community builder, Cosmin is an expert in interacting with both the technical and nontechnical worlds. With a big passion for technology and teaching, what is yet to come goes hand in hand with his vision for the future.',
    company: '',
    expertise: [
      'Blockchain',
      'Programming',
      'Public Speaking',
      'Teaching',
      'Network Marketing',
    ],
    socialIcons: [],
  },
  {
    id: 6,
    logo: zixLogo,
    position: 'Hall of Fame',
    country: '',
    photo: dummyPhoto,
    name: 'To be announced soon',
    description: '',
    backDescription: '',
    company: '',
    expertise: [],
    socialIcons: [],
  },
  {
    id: 7,
    logo: null,
    position: 'Global Guest Trainer',
    country: usFlag,
    photo: profileByron,
    name: 'Byron Schrag',
    description:
      " I'm excited to have the opportunity to share with each of you some simple game-changing concepts in building and developing your businesses.",
    backDescription:
      "Byron is passionate about helping people identify and live out the dreams God put in their heart. Whether he's talking to his kids, his friends, his business associates or someone he just met, he strives to stretch their vision and help them see God's purposes for their life.",
    company: '',
    expertise: [],
    socialIcons: [],
  },
  {
    id: 8,
    logo: zixLogo,
    position: 'WTX',
    country: grFlag,
    photo: profilePanos,
    name: 'Panos Salas',
    description:
      'This event in Barcelona will ignite ZiXXar and bring it to the next level. Being there will make you a pioneer of history.',
    backDescription:
      'An experienced trainer with over 13 years in network marketing, Panos has built teams of over 6,000 people. He is a Greek entrepreneur with Forex expertise and a co-founder of a trading system for investors.',
    company: '',
    expertise: [
      'Network Marketing',
      'Training',
      'Entrepreneur',
      'Hospitality',
      'Commerce',
      'FOREX',
    ],
    socialIcons: [],
  },
  {
    id: 9,
    logo: null,
    position: 'Global Guest Trainer',
    country: roFlag,
    photo: profileOctavian,
    name: 'Octavian Alupoaie',
    description:
      'Sales is 80% psychology, 20% strategy and it happens in your Unconscious Mind. I await you in Barcelona to discover the psychology and neuroscience behind the sales process!',
    backDescription:
      'A Sales Expert with almost two decades of experience plus over 10 years of experience in network marketing, Octavian has built international teams of tens of thousands of people and teaches the psychology behind the sales process so that people can achieve their full potential.',
    company: '',
    expertise: [],
    socialIcons: [],
  },
  {
    id: 10,
    logo: zixLogo,
    position: 'Hall of Fame',
    country: '',
    photo: dummyPhoto,
    name: 'To be announced soon',
    description: '',
    backDescription: '',
    company: '',
    expertise: [],
    socialIcons: [],
  },
]

export const speakersFlipCards = SPEAKERS_FLIP.map(
  (
    {
      id,
      logo,
      position,
      country,
      photo,
      name,
      description,
      backDescription,
      company,
      expertise,
      socialIcons,
    },
    index
  ) => (
    <div className={`col-3 card-${id}`} key={index}>
      <FlipCard
        frontContent={
          <div className='front vstack gap-2 p-3 text-black'>
            <div
              className={`d-flex align-items-center gap-3 justify-content-between ${
                logo === null && 'my-2'
              }`}
            >
              <div>
                {logo === null ? null : (
                  <img
                    src={logo}
                    alt='logo'
                    className='me-2'
                    width='48px'
                    height='48px'
                  />
                )}
                <span className='font-size-18 font-pnb'>{position}</span>
              </div>
              <img src={country} alt='' width='32px' />
            </div>
            <img src={photo} alt='' className='speaker-photo' />

            <span className='font-size-24 font-pnb'>{name}</span>
            <span className='font-size-16 color-light-grey lh-1'>
              {description}
            </span>
          </div>
        }
        backContent={
          <div className='back vstack gap-2 p-3 text-black'>
            <div
              className={`d-flex align-items-center gap-3 justify-content-between ${
                logo === null && 'my-2'
              }`}
            >
              <div>
                {logo === null ? null : (
                  <img
                    src={logo}
                    alt='logo'
                    className='me-2'
                    width='48px'
                    height='48px'
                  />
                )}
                <span className='font-size-18 font-pnb'>{position}</span>
              </div>
              <img src={country} alt='' width='32px' />
            </div>
            <span className='font-size-24 font-pnb'>{name}</span>

            <span className='color-light-grey font-size-14 lh-1'>
              {backDescription}
            </span>

            {company !== '' ? (
              <>
                <span className='font-pnb font-size-11 speaker-mini-section'>
                  COMPANY
                </span>
                <img src={company} alt='' className='cryptodata-logo' />
              </>
            ) : null}

            <div>
              {expertise.length === 0 ? null : (
                <span className='font-pnb font-size-11 speaker-mini-section'>
                  EXPERTISE
                </span>
              )}
              <div className='hstack font-pnb font-size-12 flex-wrap gap-2'>
                {expertise.map((el, index) => (
                  <span key={index} className='expertise-card'>
                    {el}
                  </span>
                ))}
              </div>
            </div>
            {/* <div className='social-icons-container align-self-end mt-auto'>
              <AiFillInfoCircle />
              {socialIcons.map((el, index) => (
                <span key={index}>{el}</span>
              ))}
            </div> */}
          </div>
        }
      />
    </div>
  )
)
